import { PlanType } from '~/generated/api-clients-generated'
import ProcessingNodeBase from '~/models/journey/ProcessingNodeBase'

export class SetSessionPlanTypeMapdNode extends ProcessingNodeBase {
  run(): Promise<void> {
    const session = SessionStore.use()

    session.planType = PlanType.MAPD

    return Promise.resolve()
  }
}
